export type InboundReceiveDraftSaveSync = "synced" | "debouncing" | "saving" | "error";

export function inboundReceiveSealBlockReason(input: {
  openContainerCount: number;
  labelPrinterSelected: boolean;
  containerTypeSelected: boolean;
  draftSaveSync: InboundReceiveDraftSaveSync;
  draftSaveError: string | null;
}): string | null {
  if (input.openContainerCount <= 0) return "Count quantity onto a line first.";
  if (!input.labelPrinterSelected) return "Select a 4x2 label printer in the header.";
  if (!input.containerTypeSelected) return "Pick a container type (bag, box, and so on).";
  if (input.draftSaveSync === "debouncing" || input.draftSaveSync === "saving") {
    return "Saving counts…";
  }
  if (input.draftSaveSync === "error") {
    return input.draftSaveError ?? "Counts did not save. Fix the error and try again.";
  }
  return null;
}

export function inboundReceiveSealReady(input: {
  openContainerCount: number;
  labelPrinterSelected: boolean;
  containerTypeSelected: boolean;
  draftSaveSync: InboundReceiveDraftSaveSync;
}): boolean {
  return (
    input.openContainerCount > 0
    && input.labelPrinterSelected
    && input.containerTypeSelected
    && input.draftSaveSync === "synced"
  );
}
